/*
  IMPORTANT: this file cannot reference any modules that are related to react & redux
  this is because service-worker runs under a different scope and cannot use those modules
*/

import { getDatabase } from 'database';
import { Guid } from 'types/guid';
import { Epc } from 'types/epc';
import { Geot } from 'types/geot-details';
import { Alert } from 'types/alert';
import { OperationItem } from 'types/operation-item';
import { NmvsActionType } from 'types/nmvs-action-type';
import { EntryMode } from 'types/entry-mode';
import { getItemAlertMessage } from './item-service';

export async function addParseAlert(rawCode: string, errorKey: string, alertReason: string, additionalMessage: string): Promise<void> {
  const db = await getDatabase();
  const clientTransactionId = Guid.newGuid();
  
  const epc: Epc = {
    rawCode,
    humanReadable: '',
    productCode: '',
    serialNumber: '',
    expiryDate: '',
    lotNumber: '',
    status: ''
  };

  const geot: Geot = {
    username: '',
    longitude: 0,
    latitude: 0
  };
  
  const item: OperationItem = {
    clientTransactionId,
    epc: epc,
    geot: geot,
    countryCode: '',
    language: '',
    operation: NmvsActionType.Unknown,
    sessionToken: '',
    scanDatetime: new Date().toISOString(),
    serverRequestStarted: '',
    isProcessing: false,
    hasError: false,
    hasAlert: false,
    alertMessage: getItemAlertMessage(errorKey, alertReason),
    entryMode: EntryMode.Automatic,
    nmvsResponseTime: 0,
    optelResponseTime: 0,
    totalResponseTime: 0
  };

  const alert: Alert = {
    item,
    errorKey,
    alertReason,
    additionalMessage
  };

  await db.add(db.config.indexes.Alert, alert, clientTransactionId);
}

export async function addAlert(key: string, item: OperationItem, errorKey: string, alertReason: string, additionalMessage: string) {
  const db = await getDatabase();
  // determine if an alert needs to be raised to the user
  if (alertReason) {
    const alert: Alert = {
      item,
      errorKey,
      alertReason,
      additionalMessage
    };

    // add to alert index
    await db.add(db.config.indexes.Alert, alert, key);
  }
}


// WEBPACK FOOTER //
// ./src/services/alert-service.ts